import React, { useRef } from 'react';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { Captcha } from '../util/varios'

export function Mensaje(props) {
    const btnAceptar = useRef();


    return (

        <Modal
            {...props}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => { btnAceptar.current.focus(); }}
        >
            <Modal.Header style={{ backgroundColor: "#007bff", color: "#fff" }}>
                <Modal.Title><i>{props.titulo}</i></Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <p style={{ textAlign: 'center', fontFamily: 'initial' }}>{props.mensaje}</p>
            </Modal.Body>
            <Modal.Footer >
                <Button ref={btnAceptar} style={{ width: 80 }} onClick={props.onHide}><i className="fa">Aceptar</i></Button>
            </Modal.Footer>
        </Modal>
    );
}

export const MensajeSiNo = (props) => {
    const btnSi = useRef();
    const btnNo = useRef();
    return (
        <Modal
            {...props}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => { btnSi.current.focus() }}
        >
            <Modal.Header style={{ backgroundColor: "#007bff", color: "#fff" }}>
                <Modal.Title><i>{props.titulo}</i></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={{ textAlign: 'center', fontFamily: 'initial' }}>{props.mensaje}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button ref={btnSi} style={{ width: 80 }} onClick={props.onHideSi} variant="primary" ><i className="fa">Si</i></Button>
                <Button ref={btnNo} style={{ width: 80 }} onClick={props.onHideNo} variant="secondary"><i className="fa">No</i></Button>
            </Modal.Footer>
        </Modal>
    );
}

export const MensajeCapcha = (props) => {
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtValor = useRef();

    const handleInputChange = (event) => {

        if (event.which === 13) {
            if (event.target.value.trim() === '') {
                txtValor.current.focus();
            } else {
                btnAcepta.current.focus();
            }


        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    }
    return (
        <Modal
            {...props}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => { Captcha(); txtValor.current.focus() }}
        >
            <Modal.Header>
                <Modal.Title><i>Confirmación</i></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <h4>Imagen de Seguridad:</h4>
                    <h4>Introduzca el Código de la Imagen:</h4>
                    <table>
                        <tbody><tr>
                            <td>
                                <canvas id="captcha">
                                </canvas></td>
                        </tr>
                            <tr>
                                <td>
                                    <input ref={txtValor} autoFocus type="text" className="input-group" id="txtInput" onKeyUp={handleInputChange} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input type="button" id="refresh" className="btn btn-success" defaultValue="actualizar" onClick={Captcha} />
                                </td>
                            </tr>
                        </tbody></table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button ref={btnAcepta} onClick={props.onHideAcepta} className="btn btn-primary"><i className="fa">  Aceptar</i></button>
                <button ref={btnCancela} onClick={props.onHideCancela} className="btn btn-danger"><i className="fa"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}